import { selectDictMoModel } from '@src/modules/dictionaries/store'
import { Combobox } from '@src/components'
import { REGISTER_COLUMNS } from '@src/constants'
import { RegisterColumn } from './RegisterColumn'

export class MgiLabMoColumn extends RegisterColumn {
  static type = REGISTER_COLUMNS.MGI_LAB_MO

  constructor (store, settings) {
    const column = {
      header: {
        title: 'Название лаборатории МГИ',
        component: Combobox,
        props: {
          allowClear: true,
          mode: 'multiple',
          options: selectDictMoModel(store.getState()).payload.data.map(mo => ({
            label: mo.name_short,
            value: mo.mo_id,
            title: mo.name_full,
          })),
        },
        defaultValue: [],
      },
      width: 300,
      dataIndex: 'mgi_lab_mo_name',
      dataRender: mgi_lab_mo_name => mgi_lab_mo_name ? mgi_lab_mo_name : '-',
      sort: true,
      nullSearch: true,
    }

    super(column, settings)
  }

  _requestArgs ({ filters, nullSearches }) {
    let requestFilters = []

    if (filters?.mgi_lab_mo_oid && filters?.mgi_lab_mo_oid.length) {
      requestFilters = [{ field: 'mgi_lab_mo_oid', value: filters.mgi_lab_mo_oid, operator: '=', invalid: false, cast: 'right-any' }]
    }

    if (nullSearches[this.type]) {
      requestFilters = [{ field: this.type, operator: '=', value: null, invalid: false }]
    }

    return {
      control: {
        filters: requestFilters,
      },
    }
  }
}
